import type { BetaUseCase } from './betaApi'
import { enPlural, ruPlural } from '@/i18n'

export const betaT = {
  en: {
    betaTitle: 'Closed beta in progress',
    betaDesc: "We're opening access gradually to give every user the best experience.",
    inQueue: 'On the waitlist:',
    // Число ещё не приехало (`null`) — множественное: «– people».
    people: (n: number | null) => (n === null ? 'people' : enPlural(n, 'person', 'people')),
    earlyAccess: 'Get early access',
    surveyTitle: 'How do you plan to use OA Studio?',
    submit: 'Submit',
    sending: 'Sending…',
    back: 'Back',
    options: {
      publish: 'Publish courses on Open Academy and earn',
      audience: 'Create courses for my audience',
      employees: 'Train employees in a company',
      knowledge: 'Structure my knowledge',
      explore: 'Just want to see what it is',
    } satisfies Record<BetaUseCase, string>,
    thankYou: "Thank you, you're on the waitlist!",
    thankDesc:
      "We're granting access gradually. Priority goes to active community members, authors, and experts. We'll notify you via email or Telegram.",
    tryApp: 'Meanwhile, try our learning app',
    soon: 'Soon',
    followUs: 'Follow us for updates',
    support: 'Support',
    signOut: 'Sign out',
    applicationAlreadySubmitted: 'You’ve already applied',
    submitFailed: 'Couldn’t submit your application',
  },
  ru: {
    betaTitle: 'Идёт закрытое бета-тестирование',
    betaDesc:
      'Мы открываем доступ постепенно, чтобы обеспечить лучший опыт для каждого пользователя.',
    inQueue: 'В очереди:',
    people: (n: number | null) =>
      n === null ? 'человек' : ruPlural(n, 'человек', 'человека', 'человек'),
    earlyAccess: 'Получить ранний доступ',
    surveyTitle: 'Как вы планируете использовать OA Studio?',
    submit: 'Отправить',
    sending: 'Отправка…',
    back: 'Назад',
    options: {
      publish: 'Публиковать курсы в Open Academy и зарабатывать',
      audience: 'Создавать курсы для своей аудитории',
      employees: 'Обучать сотрудников в компании',
      knowledge: 'Структурировать свои знания',
      explore: 'Просто хочу посмотреть, что это',
    } satisfies Record<BetaUseCase, string>,
    thankYou: 'Спасибо, вы в списке ожидания!',
    thankDesc:
      'Мы выдаём доступ постепенно. В приоритете — активные участники сообщества, авторы и эксперты. Уведомим вас по email или в Telegram.',
    tryApp: 'А пока попробуйте наше приложение с курсами',
    soon: 'скоро',
    followUs: 'Подпишитесь, чтобы следить за новостями',
    support: 'Поддержка',
    signOut: 'Выйти',
    applicationAlreadySubmitted: 'Заявка уже отправлена',
    submitFailed: 'Не удалось отправить заявку',
  },
}
